/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetBoughtItemsOutfitsQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
  numOutfits: Types.Scalars["Int"]["input"];
}>;
export type GetBoughtItemsOutfitsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    outfitCollection: {
      __typename?: "OutfitCollection";
      name: string;
      outfits: {
        __typename?: "OutfitConnection";
        nodes: Array<{
          __typename?: "Outfit";
          id: string;
          items: Array<{
            __typename?: "OutfitItem";
            sticker?: {
              __typename?: "ModeStickerLabel";
              label: string;
              theme: Types.ModeStickerLabelTheme;
            } | null;
            laydown: {
              __typename?: "OutfitItemLaydown";
              maxHeight: number;
              maxWidth: number;
              x: number;
              y: number;
              xAnchor: string;
              yAnchor: string;
            };
            shopProductVariant?: {
              __typename?: "ShopProductVariant";
              sku: string;
              url: string;
              image?: {
                __typename?: "ShopMedia";
                id: string;
                altText: string;
                imageUrl: string;
              } | null;
            } | null;
          }>;
        }>;
      };
    };
  } | null;
};
export type BoughtItemsOutfitFragment = {
  __typename?: "Outfit";
  id: string;
  items: Array<{
    __typename?: "OutfitItem";
    sticker?: {
      __typename?: "ModeStickerLabel";
      label: string;
      theme: Types.ModeStickerLabelTheme;
    } | null;
    laydown: {
      __typename?: "OutfitItemLaydown";
      maxHeight: number;
      maxWidth: number;
      x: number;
      y: number;
      xAnchor: string;
      yAnchor: string;
    };
    shopProductVariant?: {
      __typename?: "ShopProductVariant";
      sku: string;
      url: string;
      image?: {
        __typename?: "ShopMedia";
        id: string;
        altText: string;
        imageUrl: string;
      } | null;
    } | null;
  }>;
};
export type BoughtItemOutfitItemFragment = {
  __typename?: "OutfitItem";
  sticker?: {
    __typename?: "ModeStickerLabel";
    label: string;
    theme: Types.ModeStickerLabelTheme;
  } | null;
  laydown: {
    __typename?: "OutfitItemLaydown";
    maxHeight: number;
    maxWidth: number;
    x: number;
    y: number;
    xAnchor: string;
    yAnchor: string;
  };
  shopProductVariant?: {
    __typename?: "ShopProductVariant";
    sku: string;
    url: string;
    image?: {
      __typename?: "ShopMedia";
      id: string;
      altText: string;
      imageUrl: string;
    } | null;
  } | null;
};
export const BoughtItemOutfitItemFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemOutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const BoughtItemsOutfitFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsOutfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemOutfitItem"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemOutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetBoughtItemsOutfitsDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getBoughtItemsOutfits"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "id"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "numOutfits"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "outfitCollection"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "id"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "outfits"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "first"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "numOutfits"
                    }
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "nodes"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "BoughtItemsOutfit"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemOutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsOutfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemOutfitItem"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetBoughtItemsOutfitsQuery__
 *
 * To run a query within a React component, call `useGetBoughtItemsOutfitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtItemsOutfitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtItemsOutfitsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      numOutfits: // value for 'numOutfits'
 *   },
 * });
 */
export function useGetBoughtItemsOutfitsQuery(baseOptions: Apollo.QueryHookOptions<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables> & ({
  variables: GetBoughtItemsOutfitsQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>(GetBoughtItemsOutfitsDocument, options);
}
export function useGetBoughtItemsOutfitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>(GetBoughtItemsOutfitsDocument, options);
}
// @ts-ignore
export function useGetBoughtItemsOutfitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>;
export function useGetBoughtItemsOutfitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBoughtItemsOutfitsQuery | undefined, GetBoughtItemsOutfitsQueryVariables>;
export function useGetBoughtItemsOutfitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>(GetBoughtItemsOutfitsDocument, options);
}
export type GetBoughtItemsOutfitsQueryHookResult = ReturnType<typeof useGetBoughtItemsOutfitsQuery>;
export type GetBoughtItemsOutfitsLazyQueryHookResult = ReturnType<typeof useGetBoughtItemsOutfitsLazyQuery>;
export type GetBoughtItemsOutfitsSuspenseQueryHookResult = ReturnType<typeof useGetBoughtItemsOutfitsSuspenseQuery>;
export type GetBoughtItemsOutfitsQueryResult = Apollo.QueryResult<GetBoughtItemsOutfitsQuery, GetBoughtItemsOutfitsQueryVariables>;